export const API = {
	tickets: {
    create: `/ticket`,
    edit: `/ticket/`,
    delete: `/ticket/`,
    list: `/ticket`,
    getByDateRange: `/ticket/date-range`,
    generatePDF: `/ticket/generate-pdf`,
    report: `/ticket/report`,
  },
	applications: {
    create: `/application`,
    edit: `/application/`,
    delete: `/application/`,
    list: `/application`,
  },
  auth: {
    login: `/user/login`,
    check2FA: `/user/check2FA`,
  },
  users: {
    profile: `/user/profile`,
    create: `/user/register/`,
    edit: `/user/`,
    delete: `/user/`,
    list: `/user`,
  },
  alerts: {
    create: `/alert`,
    edit: `/alert/`,
    delete: `/alert/`,
    list: `/alert`,
  },
  imputHours: {
    create: `/imputhour`,
    edit: `/imputhour/`,
    delete: `/imputhour/`,
    list: `/imputhour`,
    exportByApplication: `/imputhour/export/`,
    exportByApplicationPost: `/imputhour/export`,
    exportMultipleApplications: `/imputhour/export-multiple`,
    notifyMissingProject: `/imputhour/notify-missing-project`,
  },
  projects: {
    list: `/project`,
  },
};
